const permissions =
{
    "Create Role": "Utwórz rolę",
    "Save Changes": "Zapisz zmiany",
    "Roles": "Role",
    "Role Edit": "Edycja roli",
    "Are you sure you want to delete this role?": "Na pewno usunąć rolę?",
    "Role Name": "Nazwa roli",
    "Role Name (translations)": "Nazwa roli (tłumaczenia)",
    "Role Permissions": "Uprawnienia roli",
};
export default permissions;